import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="bg-[#ebe6db] pt-12 pb-24">
      <div className="max-w-[1200px] mx-auto w-[95%] mobile:max-w-96 mobile:w-[90%]">
        <div className="w-full flex justify-between pb-12 text-base mobile:flex-col-reverse">
          <div className="[*&>:not(:last-child)]:mb-7 [*&>:not(:last-child)]:mobile:mb-5">
            <div className="flex flex-row gap-4 font-inter font-light">
              <img className="w-[22px] h-[22px]" src="./icon-phone.svg" alt="" />
              <p>(04)2202-8800</p>
            </div>
            <div className="flex flex-row gap-4">
            </div>
            <div className="flex flex-row gap-4">
              <img className="w-[22px] h-[22px]" src="./icon-address.svg" alt="" />
              <p>404台中市北區中清路一段79號10樓</p>
            </div>
          </div>
          <ul className="flex gap-11 font-inter font-light mobile:gap-0 mobile:justify-between mobile:mb-12">
            <li>
              <Link to="/branchList">公司據點</Link>
            </li>
            <li>
              <Link to="/about">集團介紹</Link>
            </li>
            <li>
              <Link to="/socialActivity">社團活動</Link>
            </li>
            <li>
              <Link to="/eliteRecruitment">菁英招募</Link>
            </li>
          </ul>
        </div>
        <div className="border-t-[1px] border border-t-[#a0a0a0] pt-5">
          <p className="font-inter text-[#a0a0a0] text-center text-[15px]">
            COPYRIGHT © 2024 ASI ASSETS MANAGEMENT CONTULTANTS CORP. ALL RIGNTS RESERVED.
          </p>
        </div>
      </div>
    </footer>
  );
}
